export const TdGap = ({ isSticky }: { isSticky?: boolean }) => (
  <td className="td-gap" style={isSticky ? { position: 'sticky', left: '16rem' } : undefined} />
);
